<div class="appContentsContainer">
  <form
    (ngSubmit)="onSave()"
    class="formGroup container halfForm wrapHalfRows"
    [ngClass]="{
      watchBothDetail: changeToStatePF.watchBoth,
      allWidth: changeToStatePF.onlyWatchDetail,
      decreaseEditor: changeToStatePF.onlyWatchEditor
    }"
    *ngIf="certificate"
  >
    <div *ngIf="changeToStatePF.isAtStatePF" class="mt-1">
      <div>
        <button
          (click)="changeViewAtPF('detail')"
          class="formButtonBack mr-2"
          type="button"
        >
          <em class="fas fa-angle-left"></em>
        </button>

        <button
          (click)="changeViewAtPF('both')"
          class="formButtonBack mr-2"
          type="button"
        >
          <em class="fas fa-angle-left"></em>
          <em class="fas fa-angle-right fa"></em>
        </button>

        <button
          (click)="changeViewAtPF('editor')"
          class="formButtonBack mr-2"
          type="button"
        >
          <em class="fas fa-angle-right fa"></em>
        </button>
      </div>

      <div style="margin-top: 10px">
        <button
          (click)="previewPDF()"
          class="formButtonBack mr-2"
          type="button"
          title="Previsualizar PDF"
          *ngIf="!onlyViewPdf"
        >
          <em class="fas fa-file-pdf far"></em>
        </button>
      </div>

      <ng-container
        *ngIf="
          (!onlyViewImpreso && !changeToStatePF.onlyWatchEditor) ||
          (onlyViewImpreso &&
            (isRHomologOrRevi() || isAnalist()) &&
            !changeToStatePF.onlyWatchEditor)
        "
      >
        <div class="row compressedRow mt-2">
          <div class="itemContainer col">
            <div class="seachLabel inputLabelContainer">
              <div class="inputLabel">
                <label>Precio (€)</label>
              </div>
            </div>

            <div class="inputContainer">
              <input
                class="inputSearch"
                type="number"
                [(ngModel)]="changeToStatePF.values.price"
                [readOnly]="readOnlyPrice()"
                name="price"
                style="max-width: 200px; min-width: 200px"
              />
            </div>
          </div>
        </div>

        <ng-container *ngIf="showTemplateList()">
          <div
            class="row compressedRow"
            *ngFor="
              let templateSublist of changeToStatePF.templateList;
              index as i
            "
          >
            <div class="itemContainer col">
              <div class="seachLabel inputLabelContainer">
                <div class="inputLabel">
                  <label
                    *ngIf="
                      certificate?.peTcertificado != 'RE';
                      then otros;
                      else reforma
                    "
                  ></label>

                  <ng-template #otros>
                    Plantilla
                    {{
                      templateSublist[0].plantilla.substring(
                        0,
                        templateSublist[0].plantilla.indexOf("|")
                      )
                    }}
                  </ng-template>

                  <ng-template #reforma>
                    Plantilla [Reforma
                    {{
                      templateSublist[0].plantilla.substring(
                        0,
                        templateSublist[0].plantilla.indexOf("|")
                      )
                    }}
                    ]
                  </ng-template>
                </div>
              </div>

              <div class="inputContainer">
                <select
                  [(ngModel)]="changeToStatePF.values.template[i]"
                  name="template_{{ i }}"
                  (change)="selectTemplates()"
                  style="max-width: 200px; min-width: 200px"
                >
                  <option
                    *ngFor="let template of templateSublist; index as j"
                    value="{{ template.plantilla }}"
                  >
                    {{
                      template.plantilla.substring(
                        template.plantilla.indexOf("|") + 1
                      )
                    }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <ng-container *ngIf="!changeToStatePF.onlyWatchEditor">
      <div
        [ngClass]="{
          pageTitle:
            !changeToStatePF.onlyWatchEditor && !changeToStatePF.watchBoth,
          pageTitleAux:
            changeToStatePF.onlyWatchEditor || changeToStatePF.watchBoth
        }"
      >
        Datos generales
      </div>

      <div
        [ngClass]="{
          halfGroup:
            !changeToStatePF.watchBoth && !changeToStatePF.onlyWatchEditor,
          fullGroup:
            changeToStatePF.watchBoth || changeToStatePF.onlyWatchEditor
        }"
      >
        <div
          class="collapsibleTitle"
          [ngClass]="{
            pageTitle:
              !changeToStatePF.onlyWatchEditor && !changeToStatePF.watchBoth,
            pageTitleAux:
              changeToStatePF.onlyWatchEditor || changeToStatePF.watchBoth
          }"
        >
          <div class="collapseButtonContainer">
            <button
              type="button"
              *ngIf="!sectionHidden.peticion"
              class="submitSearchButton"
              (click)="sectionHidden.peticion = !sectionHidden.peticion"
            >
              <em class="fas fa-angle-up"></em>
            </button>

            <button
              type="button"
              *ngIf="sectionHidden.peticion"
              class="submitSearchButton"
              (click)="sectionHidden.peticion = !sectionHidden.peticion"
            >
              <em class="fas fa-angle-down"></em>
            </button>

            <div class="pageTitle collapsibleTitle">
              <div class="title halfTitle">Datos de solicitud</div>
            </div>
          </div>
        </div>

        <div *ngIf="!sectionHidden.peticion">
          <app-form-fields
            #solicitud
            [fields]="fieldsSolicitud"
          ></app-form-fields>
        </div>
      </div>

      <div
        [ngClass]="{
          halfGroup:
            !changeToStatePF.watchBoth && !changeToStatePF.onlyWatchEditor,
          fullGroup:
            changeToStatePF.watchBoth || changeToStatePF.onlyWatchEditor
        }"
      >
        <div
          class="collapsibleTitle"
          [ngClass]="{
            pageTitle:
              !changeToStatePF.onlyWatchEditor && !changeToStatePF.watchBoth,
            pageTitleAux:
              changeToStatePF.onlyWatchEditor || changeToStatePF.watchBoth
          }"
        >
          <div class="collapseButtonContainer">
            <button
              type="button"
              *ngIf="!sectionHidden.vehiculo"
              class="submitSearchButton"
              (click)="sectionHidden.vehiculo = !sectionHidden.vehiculo"
            >
              <em class="fas fa-angle-up"></em>
            </button>

            <button
              type="button"
              *ngIf="sectionHidden.vehiculo"
              class="submitSearchButton"
              (click)="sectionHidden.vehiculo = !sectionHidden.vehiculo"
            >
              <em class="fas fa-angle-down"></em>
            </button>

            <div class="pageTitle collapsibleTitle">
              <div class="title halfTitle">Datos de vehículo</div>
            </div>
          </div>
        </div>

        <div *ngIf="!sectionHidden.vehiculo">
          <app-form-fields
            #vehiculo
            [fields]="fieldsVehiculo"
          ></app-form-fields>
        </div>
      </div>

      <div class="fullGroup">
        <div
          class="collapsibleTitle"
          [ngClass]="{
            pageTitle:
              !changeToStatePF.onlyWatchEditor && !changeToStatePF.watchBoth,
            pageTitleAux:
              changeToStatePF.onlyWatchEditor || changeToStatePF.watchBoth
          }"
        >
          <div class="collapseButtonContainer">
            <button
              type="button"
              *ngIf="!sectionHidden.obs"
              class="submitSearchButton"
              (click)="sectionHidden.obs = !sectionHidden.obs"
            >
              <em class="fas fa-angle-up"></em>
            </button>

            <button
              type="button"
              *ngIf="sectionHidden.obs"
              class="submitSearchButton"
              (click)="sectionHidden.obs = !sectionHidden.obs"
            >
              <em class="fas fa-angle-down"></em>
            </button>

            <div class="pageTitle collapsibleTitle">
              <div class="title halfTitle">Comentario / Observaciones</div>
            </div>
          </div>
        </div>

        <div
          *ngIf="!sectionHidden.obs"
          [ngClass]="{
            'w-100': changeToStatePF.watchBoth,
            reponsiveWidthComentarios:
              !changeToStatePF.isAtStatePF || changeToStatePF.onlyWatchDetail
          }"
        >
          <app-form-fields
            #comentario
            [fields]="fieldsComentario"
          ></app-form-fields>
        </div>
      </div>

      <div class="fullGroup">
        <div
          class="collapsibleTitle"
          [ngClass]="{
            pageTitle:
              !changeToStatePF.onlyWatchEditor && !changeToStatePF.watchBoth,
            pageTitleAux:
              changeToStatePF.onlyWatchEditor || changeToStatePF.watchBoth
          }"
        >
          <div class="collapseButtonContainer">
            <button
              type="button"
              *ngIf="!sectionHidden.detalle"
              class="submitSearchButton"
              (click)="sectionHidden.detalle = !sectionHidden.detalle"
            >
              <em class="fas fa-angle-up"></em>
            </button>

            <button
              type="button"
              *ngIf="sectionHidden.detalle"
              class="submitSearchButton"
              (click)="sectionHidden.detalle = !sectionHidden.detalle"
            >
              <em class="fas fa-angle-down"></em>
            </button>

            <div class="pageTitle collapsibleTitle">
              <div class="title halfTitle">Detalles de solicitud</div>
            </div>
          </div>
        </div>
        <div *ngIf="!sectionHidden.detalle">
          <app-dynamic-fields
            #dynamicFields
            *ngIf="fields"
            [fields]="fields"
            [operation]="operation"
            [bastidor]="certificate?.peBastidor"
            [certificate]="certificate?.peTcertificado"
            [reform]="certificate?.peReforma"
            [tmotor]="certificate?.peTipomotor"
            [stateToPFAndWatchBoth]="
              changeToStatePF.isAtStatePF && changeToStatePF.watchBoth
            "
            (downloadFileEvent)="downloadFile($event)"
          ></app-dynamic-fields>
        </div>

        <div
          class="consultaEditarButtonGroup allWidth"
          *ngIf="
            operation == 'edit' ||
            (operation == 'detail' &&
              certificate &&
              certificate.peEstado === 'PC')
          "
        >
          <div style="margin-left: 19%">
            <div
              class="middleButtonAceptar mr-1"
              style="float: left"
              *ngIf="operation == 'edit'"
            >
              <button class="formButton" type="button" (click)="onSave()">
                {{ "commons.ok" | translate }}
              </button>
            </div>

            <div class="middleButtonAceptar" style="float: left">
              <button
                class="formButton"
                type="button"
                *ngIf="
                  operation == 'detail' &&
                  certificate &&
                  certificate.peEstado === 'PC'
                "
                (click)="goEdit()"
              >
                {{ "commons.correct" | translate }}
              </button>

              <button
                class="formButton"
                type="button"
                *ngIf="operation == 'edit'"
                (click)="goDetail()"
              >
                {{ "commons.cancel" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="fullGroup">
        <div style="margin-bottom: 5px">
          <app-comments-history-peticion
            [id]="id"
          ></app-comments-history-peticion>
        </div>
      </div>

      <div class="fullGroup" *ngIf="certificate">
        <div style="margin-bottom: 5px">
          <app-compare-release-peticion
            [type]="isReforma()"
            [id]="id"
            [isHistoric]="this.type == 'history'"
            [peticion]="certificate"
          ></app-compare-release-peticion>
        </div>
      </div>

      <div class="fullGroup" *ngIf="certificate">
        <div style="margin-bottom: 5px">
          <app-list-related-requests
            [config]="config"
          ></app-list-related-requests>
        </div>
      </div>

      <div class="fullGroup" *ngIf="showReasigneAnalyst()">
        <div style="margin-bottom: 5px">
          <app-reasigne-analyst
            [idPetition]="id"
            [analyst]="certificate.analistaNombre"
            [peRelease]="certificate.peRelease"
            (reasgine)="reasgine($event)"
          ></app-reasigne-analyst>
        </div>
      </div>

      <div class="consultaEditarButtonGroup">
        <div class="backButton" *ngIf="!changeToStatePF.isAtStatePF">
          <button class="formButton" type="button" (click)="goList()">
            <em class="fas fa-chevron-left"></em>
          </button>
        </div>

        <div class="backButton" *ngIf="changeToStatePF.isAtStatePF">
          <button class="formButton" type="button" (click)="goOutFI()">
            <em class="fas fa-chevron-left"></em>
          </button>
        </div>
      </div>

      <app-states
        #states
        class="certDetailConatiner"
        locatorClassModal="certDetailModal"
        *ngIf="certificate"
        [changeToStatePF]="changeToStatePF.isAtStatePF"
        [actualState]="certificate.peEstado"
        [idPetition]="certificate.peId"
        [release]="certificate.peRelease"
        [isAnalistaTramitante]="userIdConected === certificate.analistaId"
        [analistaByPetition]="certificate.analistaId"
        (reloadPetition)="reloadDetail($event)"
      ></app-states>
    </ng-container>
  </form>

  <app-rich-text-editor
    class="mt-3"
    *ngIf="
      changeToStatePF.isAtStatePF &&
      changeToStatePF.values.html != '' &&
      (certificate?.peTcertificado != 'OD' || !onlyViewPdf)
    "
    [ngClass]="{
      watchBothEditor: changeToStatePF.watchBoth,
      hide: changeToStatePF.onlyWatchDetail,
      increaseEditor: changeToStatePF.onlyWatchEditor
    }"
    [value]="changeToStatePF.values.html"
    [readonly]="
      (onlyViewImpreso && certificate?.peEstado !== 'CA') ||
      (!isAnalistaTramitante() && certificate?.peEstado == 'CA')
    "
  ></app-rich-text-editor>

  <app-pdf-viewer
    *ngIf="changeToStatePF.isAtStatePF && onlyViewPdf"
    [ngClass]="{
      watchBothPdf: changeToStatePF.watchBoth,
      hidePdfViewer: changeToStatePF.onlyWatchDetail,
      increaseEditor: changeToStatePF.onlyWatchEditor
    }"
    [pdfSrc]="pdfURL"
  ></app-pdf-viewer>
</div>
